<template>
  <div id="basic">
    <el-dialog title="充值记录" :visible.sync="dialogFormVisible" width="60%">
      <el-row :gutter="30" style="width: 70%; margin: 30px auto">
        <el-col :span="12">
          <div class="top-orderdetil">
            用户昵称：<span class="ztcolor">{{ getFormData.card_owner }}</span>
          </div>
          <div class="top-orderdetil">
            累计充值：<span class="ztcolor">{{
              getFormData.total_recharge_amount / 100
            }}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="top-orderdetil">
            手机号码：<span class="ztcolor">{{ getFormData.mobile }}</span>
          </div>
          <div class="top-orderdetil">
            当前余额：<span class="red">{{
              getFormData.balance / 100 || '--'
            }}</span>
          </div>
        </el-col>
      </el-row>

      <el-table
        :data="historyTableData"
        border
        style="width: 70%; margin: auto"
        :header-cell-style="() => 'text-align: center;background:#eef1f6;'"
      >
        <!-- <el-table-column prop="created_at" label="时间" width="200">
        </el-table-column> -->
        <el-table-column label="时间" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.created_at | datetime }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column
          label="状态"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag :type="scope.row.status == '已支付' ? 'success' : 'danger'">{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column> -->

        <!-- <el-table-column prop="change_balance" label="充值金额" width="200">
        </el-table-column> -->
        <el-table-column label="充值金额" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.change_balance / 100 }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column prop="device_name" label="支付方式" width="200"> -->
        <el-table-column label="支付方式" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.channel | payString }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @current-change="fromPageSize"
        background
        layout="prev, pager, next"
        :total="getFormData.total"
        :page-size="10"
      ></el-pagination>

      <!-- :page-size="getFormData.page_size" -->
    </el-dialog>

    <el-dialog title="充值" :visible.sync="dialogFormVisibleLabel">
      <el-form label-width="140px" style="width: 80%">
        <el-form-item label="用户昵称：">
          {{ getFormData.card_owner }}
        </el-form-item>
        <el-form-item label="手机号/IC卡号：">
          {{ getFormData.card_number }}
        </el-form-item>
        <el-form-item label="当前余额：">
          {{ getFormData.balance / 100 }}
        </el-form-item>
        <el-form-item label="充值金额(元)" required>
          <!-- <el-input v-model="cardMony" type="number" :precision="2"></el-input> -->
          <el-input-number
            v-model="cardMony"
            :precision="2"
            :step="0.1"
            :max="1000000000"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="渠道">
          <el-select placeholder="请选择" v-model="cardChannel">
            <el-option label="微信" value="weixin"></el-option>
            <el-option label="支付宝" value="zhifubao"></el-option>
            <el-option label="现金" value="cash"></el-option>
             <el-option label="其他" value="other"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibleLabel = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <div class="top_div">
      <!-- <h1>会员充值</h1> -->
      <el-form :inline="true" :model="formInline">
        <!-- <el-form-item label="请选择门店">
          <el-select placeholder="请选择" value>
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item>
        <div class="demo-form-inline">
          <el-form-item label="会员卡号" >
          
            <el-input v-model="card_num"></el-input>
          </el-form-item>
          <el-form-item label="类型">
            <el-select v-model="formInline.region" placeholder="请选择">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
        </div> -->

        <el-form-item label="按起止时间">
          <!-- <el-time-picker
              is-range
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              placeholder="选择时间范围"
            ></el-time-picker> -->
          <el-date-picker
            v-model="from.date"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择"
            class="dateInput"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="昵称">
          <el-input v-model="from.owner"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="from.mobile"></el-input>
        </el-form-item>
        <el-form-item label="会员类别">
          <el-select v-model="from.channel" placeholder="请选择">
            <el-option label="所有会员" value=""></el-option>
            <el-option label="小程序会员" value="WEIXIN"></el-option>
            <el-option label="IC卡会员" value="MAGCARD"></el-option>
          </el-select>
        </el-form-item>

        <div class="bottom_center">
          <el-form-item style="min-width: 150px">
            <el-button
              type="primary"
              style="background: #1890ff"
              @click="pageSize(1)"
              >查询</el-button
            >
             <el-button
            type="primary"
            class="vubutton"
            @click="resonSubmit"
          >重置</el-button>

            <download-excel
              :fetch="fetchData"
              :fields="json_fields"
              :before-generate="startDownload"
              name="会员充值列表.xls"
              style="display: inline-block; margin-left: 10px"
            >
              <el-button
                type="primary"
                :loading="upload"
                style="
                  background: #1baeae;
                  color: #fff;
                  border: none;
                  height: 40px;
                "
                >导出</el-button
              >
            </download-excel>
          </el-form-item>
        </div>

        <div>
          <span class="top-title">会员合计：</span>
          <span class="top-numnber">{{ allData.total }}</span>

          <span class="top-title">合计充值：</span>
          <span class="top-numnber"
            >¥ {{ allData.total_recharge_amount / 100 || '0' }}</span
          >

          <span class="top-title">合计余额：</span>
          <span class="top-numnber"
            >¥ {{ allData.total_balance / 100 || '0' }}</span
          >
        </div>
      </el-form>

      <el-table
        :fit="false"
        border
        :data="tableData"
        style="width: 100%"
        :cell-style="() => 'text-align: center;'"
        :header-cell-style="() => 'text-align: center;background:#eef1f6;'"
      >
        <template slot="empty">
          <noCart></noCart>
        </template>
        <!-- <el-table-column prop="id" label="序号ID"></el-table-column> -->
        <!-- <el-table-column
          prop="card_number"
          label="会员卡ID"
          min-width="200"
        ></el-table-column> -->
        <!-- <el-table-column prop="" label="生成时间" width="140px"></el-table-column> -->

        <el-table-column label="注册时间" width="240">
          <template slot-scope="scope">
            <span>{{ scope.row.created_at | datetime }}</span>
          </template>
        </el-table-column>

        <el-table-column label="手机号" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.mobile }}</span>
          </template>
        </el-table-column>

        <el-table-column label="昵称" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.card_owner }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="编辑时间" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.updated_at }}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          prop="mode"
          label="模式"
          min-width="140"
        ></el-table-column> -->
        <!-- <el-table-column
          prop="total_recharge_amount"
          label="累计充值"
          min-width="140"
        ></el-table-column> -->
        <el-table-column label="累计充值" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.total_recharge_amount / 100 }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="balance"
          label="余额"
          min-width="140"
        ></el-table-column> -->
        <el-table-column label="余额" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.balance / 100 }}</span>
          </template>
        </el-table-column>

        <!--          
        <el-table-column label="日期" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.date }}</span>
          </template>
        </el-table-column>
        <el-table-column label="时间" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="微信昵称" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="金额" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" width="250">
          <template slot-scope="scope">
            <el-link
              style="color: rgb(248, 60, 0); margin-right: 10px"
              :underline="false"
              @click="handleEdita(scope.row, 'dialogFormVisibleLabel')"
              type="warning"
              >余额充值</el-link
            >
            <el-link
              style="color: rgb(28, 165, 160)"
              :underline="false"
              @click="handleEdita(scope.row, 'dialogFormVisible')"
              type="warning"
              >充值记录</el-link
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="pageSize"
        class="pagination_em"
        background
        layout="prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'employee',
  data() {
    return {
      json_fields: {
        ID: 'id',
        卡号: 'card_number',
        姓名: 'card_owner',
        注册时间: 'created_at',
        手机号: 'mobile', //如果命名的标题有空格,需要用双引号
        性别: 'sex',
        状态: 'status',
        余额: 'balance',
        累计充值: 'total_recharge_amount',
      },
      upload: false,
      formInline: {
        user: '',
        region: '',
        total: 0,
        page_size: 10,
        date: '',
        page_no: 1,
      },
      dialogFormVisibleLabel: false,
      dialogFormVisible: false, //充值记录
      tableData: [],
      total: 0,
      page_no: 1,
      from: {
        total: 0,
        page_size: 10,
        page_no: 1,
        mobile: '',
        owner: '',
        channel: '',
        date: [],
      },
      getFormData: {},
      getFormDataPage_no: 1,
      historyTableData: [],
      allData: {},
      cardChannel: 'weixin',
      cardMony: 0,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      card_num: '',
    };
  },

  methods: {
    startDownload() {
      this.upload = true;
      // alert('show loading');
    },
    async fetchData() {
      const url = this.$userList.user_vip_list;

      const res = await this.$http.get(url, {
        page_size: this.total,
        page_no: this.page_no,
         mobile: this.from.mobile,
          owner: this.from.owner,
          channel: this.from.channel,


       
         start: (this.from.date && this.from.date[0]) || '',
          end: (this.from.date && this.from.date[1]) || '',
      });
      // console.log(af);
      let userdata = res.data.magcard || [];
      userdata.map((item) => {
        item.id = item.id.toString();
        item.balance = item.balance / 100;
        item.total_recharge_amount = item.total_recharge_amount / 100;

        item.created_at = this.dateString(item.created_at);
      });
      this.upload = false;
      // console.log('userdata: ', userdata);
      return userdata;
    },
    dateString(timeStamp) {
      var date = new Date(timeStamp);

      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? '0' + minute : minute;
      second = second < 10 ? '0' + second : second;
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
    },
      resonSubmit() {
      console.log('submit!');
      // const shop_id = this.formInline.shop_id;
      this.from = {
        total: 0,
        page_size: 10,
        page_no: 1,
        mobile: '',
        owner: '',
        channel: '',
        date: [],
      };
       this.page_no = 1;
      this.getList();
    },
    getList() {
      //  owner=trump&card_num=a0000
      // this.listloading = true;
      const url = this.$userList.user_vip_list;
      this.$http
        .get(url, {
          mobile: this.from.mobile,
          owner: this.from.owner,
          channel: this.from.channel,

          start: (this.from.date && this.from.date[0]) || '',
          end: (this.from.date && this.from.date[1]) || '',
          page_size: 10,
          page_no: this.page_no,
          // query_all:true,
        })
        .then((res) => {
          // console.log('res: ', res);
          // this.listloading = false;
          if (res.code === 200) {
            console.log(res);
            this.total = res.data.total;
            this.allData = res.data;
            this.tableData = res.data.magcard;
          } else {
            //res.message && this.$alert(res.message);
          }
        });
    },
    pageSize(index) {
      this.page_no = index;
      this.getList();
    },
    onSubmit() {
      let ajaxdata = {
        magcard_id: this.getFormData.id,
        balance: parseInt(this.cardMony * 100),
        channel: this.cardChannel,
      };

      if (this.getFormData.channel == 'WEIXIN') {
        ajaxdata.client_id = this.getFormData.id;
      }

      this.$http
        .post(this.$userList.user_cardRecharge, ajaxdata)
        .then((res) => {
          if (res.code == 200) {
            this.$message.success('成功');
            this.dialogFormVisibleLabel = false;
            this.getList();
          } else {
            this.$message.error(res.message);
          }
          // this.$alert('fawf');
        });
    },
    handleEdita(row, type) {
      // console.log(index, row);dialogFormVisible
      // this.from = row;
      if (type == 'dialogFormVisibleLabel') {
        //充值
        this.dialogFormVisibleLabel = true;
        this.getFormData = row;
        this.cardMony = 10;
      } else {
        this.getFormlist(row);
        this.dialogFormVisible = true;
      }
    },
    getFormlist(userData) {
      // if (userData) {
      this.getFormData = userData;
      // }
      const url = this.$userList.user_cardHistory_list;
      this.$http
        .get(url + userData.id, {
          page_size: 10,
          page_no: this.getFormDataPage_no,
          mode: 'RECHARGE',
        })
        .then((res) => {
          // this.listloading = false;
          if (res.code === 200) {
            // console.log(res);
            // this.total = res.data.total;
            this.getFormData.total = res.data.total;
            this.historyTableData = res.data.magcard_history;
          } else {
            //res.message && this.$alert(res.message);
          }
        });
    },
    fromPageSize(index) {
      console.log('index: ', index);
      this.getFormDataPage_no = index;
      this.getFormlist(this.getFormData);
    },
  },
  created() {
    this.getList();
    this.$root.headName = ['会员管理', '会员充值'];
  },
};
</script>

<style lang="scss" scoped>
#basic {
  width: 100%;
  height: 100%;
  position: relative;
}
.top_div {
  width: 100%;
  height: auto !important;
  box-sizing: border-box;
  padding: 20px;
  background: #fff;
}
.demo-form-inline {
  display: flex;
  justify-content: flex-start;
}
/* .el-select > .el-input,
.el-input__inner {
  width: 300px;
} */
.vubutton {
  background: #fff;
  border: solid 1px #1890ff;
  color: #1890ff;
}
.el-button--primary:hover,
.el-button--primary:active,
.el-button--primary:focus {
  background: #1890ff;
  border-color: #1890ff;
}
.el-table--group::after,
.el-table--border::after,
.el-table::before {
  background: none;
}
.el-form--inline .el-form-item {
  margin-right: 50px;
}
.center_div {
  margin-top: 20px;
  background: #fff;
  box-sizing: border-box;
  padding: 20px;
}
.el-table__empty-block {
  width: none !important;
}
.center_div_border {
  margin-top: 20px;
  width: 100%;
  min-height: 300px;
  background: brown;
}
.bottom_center {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.top-title {
  font-weight: 400;
  color: #606266;
  font-size: 14px;
  margin-right: 10px;
}
.top-numnber {
  font-weight: 700;
  line-height: 40px;
  font-size: 23px;
  color: rgb(41, 147, 179);
  margin-right: 30px;
}
.top-orderdetil {
  // padding-left: 10%;
  font-size: 16px;
  line-height: 30px;
  color: #333333;
  // font-weight: 700;
  .ztcolor {
    color: rgb(72, 128, 135);
  }
  .red {
    color: #f33;
  }
}
</style>
